import React from "react";
import { Link } from "react-router-dom";

function PageHero({
  eyebrow,
  title,
  description,
  primaryAction,
  secondaryAction,
  image,
  imageAlt,
  imageLight = false,
  compact = false,
  children
}) {
  return (
    <section className={`page-hero ${compact ? "compact" : ""}`}>
      <div className="container">
        <div className="row align-items-center g-5">
          <div className="col-lg-6">
            {eyebrow ? <span className="eyebrow-badge">{eyebrow}</span> : null}
            <h1>{title}</h1>
            {description ? <p className="hero-copy">{description}</p> : null}
            {(primaryAction || secondaryAction) ? (
              <div className="hero-actions">
                {primaryAction ? <Link className="site-primary-cta" to={primaryAction.to}>{primaryAction.label}</Link> : null}
                {secondaryAction ? <Link className="site-secondary-cta" to={secondaryAction.to}>{secondaryAction.label}</Link> : null}
              </div>
            ) : null}
            {children}
          </div>
          <div className="col-lg-6">
            <div className={`hero-visual-card compact ${imageLight ? "light" : ""}`}>
              <img src={image} alt={imageAlt} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default PageHero;
